"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var redux_1 = require("redux");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HoCs_1 = require("utils/HoCs");
var data_1 = require("utils/selectors/data");
var AnalyserForm_1 = __importDefault(require("./AnalyserForm"));
var QuoteAnalyser = function () {
    var _a;
    var _b = (0, react_router_dom_1.useParams)(), analysisBundledId = _b.analysisBundledId, analysisId = _b.analysisId;
    var analysisBundlesData = (0, react_redux_1.useSelector)(data_1.selectQuoteAnalysisBundlesData);
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'quote_report_bundles', doc: analysisBundledId }]; });
    if (!(0, react_redux_firebase_1.isLoaded)(analysisBundlesData)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var analysisBundle = analysisBundlesData === null || analysisBundlesData === void 0 ? void 0 : analysisBundlesData[analysisBundledId];
    var actualAnalysisId = analysisId !== null && analysisId !== void 0 ? analysisId : (_a = analysisBundle === null || analysisBundle === void 0 ? void 0 : analysisBundle.quoteAnalysisIds) === null || _a === void 0 ? void 0 : _a.at(-1);
    if (!actualAnalysisId || !(analysisBundle === null || analysisBundle === void 0 ? void 0 : analysisBundle.quoteAnalysisMap[actualAnalysisId])) {
        return (0, jsx_runtime_1.jsx)("div", { children: "Not Found" });
    }
    return (0, jsx_runtime_1.jsx)(AnalyserForm_1.default, { quoteAnalysisBundle: __assign({ id: analysisBundledId }, analysisBundle), quoteAnalysisId: actualAnalysisId });
};
exports.default = (0, redux_1.compose)(HoCs_1.HasCompanyHoC, react_1.memo, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'serviceName', order: 1 }); })(QuoteAnalyser);
